/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Collateral { 
    memberId?: number | null;
    blockAmount?: number | null;
    collateralType?: string | null;
    assetName?: string | null;
    assetType?: string | null;
    currentValuation?: number | null;
    comment?: string | null;
    document?: string | null;
    shareSavingId?: number | null;
}

